if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();

        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        // Ensure popupBg is added before the drawer
        let popupBg = document.querySelector('.popupBg');
        if (!popupBg) {
          popupBg = document.createElement('div');
          popupBg.classList.add('popupBg');
          document.body.appendChild(popupBg); // Add the popup background
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        this.pickupInput = this.querySelector('.pickup-location-search__input');
      }

      connectedCallback() {
        this.search();
        this.checkAvailability();
      }

      checkAvailability() {
        const pickupList = this.querySelectorAll('.pickup-availability-list__item');
        const unavailableMessage = this.querySelector('.pickup-availability-unavailable-message');
        const parentList = this.querySelector('.pickup-availability-list');

        if (pickupList.length === 0) {
          // No locations available - show unavailable message
          if (unavailableMessage) {
            unavailableMessage.style.display = 'block';
          }
          if (parentList) {
            parentList.style.display = 'none';
          }
        } else {
          // Locations available - hide unavailable message
          if (unavailableMessage) {
            unavailableMessage.style.display = 'none';
          }
          if (parentList) {
            parentList.style.display = 'block';
          }
        }
      }

      search() {
        let timeout;
        let postcodeURL = this.pickupInput.dataset.postcodeUrl;

        this.pickupInput.addEventListener('input', (e) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            const query = e.target.value.trim();

            if (query) {
              fetch(`${postcodeURL}?q=${query}`)
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                  }
                  return response.json();
                })
                .then((data) => {
                  if (data[query]) {
                    const userCoordinates = data[query];
                    console.log(`Coordinates for ${query}:`, userCoordinates);

                    this.sortPickupLocations(userCoordinates);
                  } else {
                    console.warn(`No coordinates found for ${query}`);
                  }
                })
                .catch((error) => {
                  console.error(`Error fetching data for ${query}:`, error);
                });
            }
          }, 500);
        });
      }

      sortPickupLocations(userCoordinates) {
        const { latitude: userLat, longitude: userLng } = {
          latitude: userCoordinates[0],
          longitude: userCoordinates[1],
        };

        const pickupList = this.querySelectorAll('.pickup-availability-list__item');
        const parentList = this.querySelector('.pickup-availability-list');
        const unavailableMessage = this.querySelector('.pickup-availability-unavailable-message');

        // Check if there are no pickup locations available
        if (pickupList.length === 0) {
          // Show unavailable message and hide the list
          if (unavailableMessage) {
            unavailableMessage.style.display = 'block';
          }
          parentList.style.display = 'none';
          return;
        }

        // Hide unavailable message and show the list
        if (unavailableMessage) {
          unavailableMessage.style.display = 'none';
        }
        parentList.style.display = 'block';

        const calculateDistance = (lat1, lng1, lat2, lng2) => {
          const R = 6371;
          const dLat = (lat2 - lat1) * (Math.PI / 180);
          const dLng = (lng2 - lng1) * (Math.PI / 180);
          const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLng / 2) ** 2;
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          return R * c;
        };

        const locations = Array.from(pickupList).map((item) => {
          const coordinates = JSON.parse(item.getAttribute('data-coordinates'));
          const [lat, lng] = coordinates;

          return {
            element: item,
            distance: calculateDistance(userLat, userLng, lat, lng),
          };
        });

        locations.sort((a, b) => a.distance - b.distance);

        parentList.innerHTML = '';
        locations.forEach(({ element, distance }) => {
          const preview = element.querySelector('.pickup-availability-preview');
          preview.innerHTML = preview.innerHTML.split('(')[0].trim();

          preview.innerHTML += ` (${distance.toFixed(2)} km)`;

          parentList.appendChild(element);
        });
      }

      getLocationCoordinates() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            this.handlePosition.bind(this),
            (err) => console.error('Geolocation error:', err),
            { enableHighAccuracy: true, timeout: 10000 }
          );
        } else {
          console.warn("Geolocation is not supported by this browser.");
        }
      }

      handlePosition(position) {
        const { latitude, longitude } = position.coords;
        this.getPostcode(latitude, longitude);
      }

      getPostcode(lat, lng) {
        const apiKey = window.google?.map?.apiKey;
        if (!apiKey || apiKey === '') {
          console.warn('Google Maps API key not found');
          return;
        }

        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        fetch(url)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`Geocoding API returned status ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            // Check API status
            if (data.status !== 'OK') {
              console.warn(`Geocoding API status: ${data.status}`, data.error_message || '');
              return;
            }

            const first = data.results?.[0];
            if (!first) {
              console.warn('No geocoding results found for coordinates:', lat, lng);
              return;
            }

            const comp = first.address_components.find((c) =>
              c.types.includes('postal_code')
            );
            if (!comp) {
              console.warn('No postal_code found in address components for this location');
              return;
            }

            // Fill the input and trigger your existing search debounce
            this.pickupInput.value = comp.long_name;
            this.pickupInput.dispatchEvent(new Event('input', { bubbles: true }));
          })
          .catch((err) => {
            console.error('Error fetching postcode:', err.message);
          });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        this.pickupInput.value = '';
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);

        // Hide the background when the drawer is closed
        const popupBg = document.querySelector('.popupBg');
        if (popupBg) {
          popupBg.classList.remove('popupBg-visible');
        }
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);

        // Ensure popup background stays in place when the drawer is shown
        let popupBg = document.querySelector('.popupBg');
        if (!popupBg) {
          popupBg = document.createElement('div');
          popupBg.classList.add('popupBg');
          document.body.appendChild(popupBg);
        }

        // Add the visible class to force display
        popupBg.classList.add('popupBg-visible');
        this.getLocationCoordinates();
      }
    }
  );
}
